import React, { Fragment, useState, useContext } from "react";
import Icon from "../../Icon";
import { EligibilityContext } from "../../../contexts/EligibilityContext";
import FundFinder from "../shared/FundFinder";
import TransportationResources from "../shared/TransportationResources";

import { notDiseaseFund } from "../../../helpers/fund";

const ExternalFunds = () => {
  const context = useContext(EligibilityContext);
  const [expanded, setExpanded] = useState(false);

  return (
    <Fragment>

      {/* If the transportation fund was selected show trasportation resources */}
      {notDiseaseFund(context.state.diseaseFund.groupId) && (
        <TransportationResources />
      )}
      

      {context.state.response.AssistancePrograms.length > 0 && (
        <Fragment>
          <p className="f-h5 c-purple u-mb1">Find funds from other organizations</p>
          <p>Contact these organizations and assistance programs to see if they have funding available.</p>

          {!expanded && (
            <button
              className="btn--transparentIcon Card-inner-content-eligibilityExpand f-medium"
              onClick={() => setExpanded(true)}
              type="button"
            >
              <Icon name="plus" />
              See Organizations
            </button>
          )}

          {expanded && (
            <Fragment>
              <button
                className="btn--transparentIcon u-mb2 Card-inner-content-eligibilityExpand f-medium"
                onClick={() => setExpanded(false)}
                type="button"
              >
                <Icon name="minus" />
                Hide Organizations
              </button>

              {context.state.response.AssistancePrograms.map((program, i) => (
                <p key={i}>
                  <a
                    href={program.Website}
                    className="f-bold ga-wizardAssistanceProgramLink"
                  >
                    {program.Name} <Icon name="externalLink" width="16" />
                  </a>
                  <br />
                  {program.Phone && <Fragment>{program.Phone}</Fragment>}
                </p>
              ))}

            </Fragment>
          )}
        </Fragment>
      )}
      {/* otherwise show fund finder */}
      {!notDiseaseFund(context.state.diseaseFund.groupId) && <FundFinder />}

    </Fragment>
  );
};

export default ExternalFunds;
